import { Spin } from 'antd'
import React from 'react'

export const DHSIntegrationSettingsLoading: React.FC = () => {
  return (
    <div style={{ padding: '24px', background: '#fff', minHeight: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Spin size="large" tip="Loading DHS Integration Settings..." />
    </div>
  )
}
